import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconUnlocked: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"unlocked, unlock, private"} maskId="square-filled-radius-0-stroke-1-IconUnlocked"><path fillRule="evenodd" clipRule="evenodd" d="M12 2C9.79086 2 8 3.79086 8 6V9H4V22H20V9H9V6C9 4.34315 10.3431 3 12 3C13.6569 3 15 4.34315 15 6V7H16V6C16 3.79086 14.2091 2 12 2ZM12.5 13.5V17.5H11.5V13.5H12.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconUnlocked;
